import { jsx as r, jsxs as a } from "react/jsx-runtime";
import { Accordion as n } from "@base-ui/react/accordion";
import { cn as t } from "../../lib/utils.js";
import { ChevronDownIcon as c, ChevronUpIcon as d } from "lucide-react";
function u({ className: o, ...e }) {
  return /* @__PURE__ */ r(
    n.Root,
    {
      "data-slot": "accordion",
      className: t("flex w-full flex-col", o),
      ...e
    }
  );
}
function f({ className: o, ...e }) {
  return /* @__PURE__ */ r(
    n.Item,
    {
      "data-slot": "accordion-item",
      className: t("not-last:border-b", o),
      ...e
    }
  );
}
function p({
  className: o,
  children: e,
  ...i
}) {
  return /* @__PURE__ */ r(n.Header, { className: "flex", children: /* @__PURE__ */ a(
    n.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: t(
        "group/accordion-trigger relative flex flex-1 items-start justify-between rounded-lg border border-transparent py-2.5 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:after:border-ring aria-disabled:pointer-events-none aria-disabled:opacity-50 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 **:data-[slot=accordion-trigger-icon]:text-muted-foreground",
        o
      ),
      ...i,
      children: [
        e,
        /* @__PURE__ */ r(c, { "data-slot": "accordion-trigger-icon", className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden" }),
        /* @__PURE__ */ r(d, { "data-slot": "accordion-trigger-icon", className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline" })
      ]
    }
  ) });
}
function h({
  className: o,
  children: e,
  ...i
}) {
  return /* @__PURE__ */ r(
    n.Panel,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm data-open:animate-accordion-down data-closed:animate-accordion-up",
      ...i,
      children: /* @__PURE__ */ r(
        "div",
        {
          className: t(
            "h-(--accordion-panel-height) pt-0 pb-2.5 data-ending-style:h-0 data-starting-style:h-0 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4",
            o
          ),
          children: e
        }
      )
    }
  );
}
export {
  u as Accordion,
  h as AccordionContent,
  f as AccordionItem,
  p as AccordionTrigger
};
//# sourceMappingURL=accordion.js.map
